import * as React from "react";
import PropTypes from "prop-types";
import bankersRounding from 'bankers-rounding';
import {GridFooterContainer, gridPaginationRowRangeSelector } from "@mui/x-data-grid";
import MDTypography from "components/MDTypography";
import { Stack } from "@mui/system";
import { formatNumber } from "accounting-js";
import { gridColumnPositionsSelector, useGridApiContext, gridPageCountSelector, useGridSelector } from "@mui/x-data-grid";
import {Pagination} from "@mui/material";
import {PaginationItem} from "@mui/material";

import * as Styled from './footerTotals.styles'

function format(value) {
  if(value == null) { return '0,00'; }
  return formatNumber(value, { precision: 2, thousand: " ", decimal: "," });
}

function CustomTotalsComponent(props) {

  const apiRef = useGridApiContext();
  const columnPositionsSelector = gridColumnPositionsSelector(apiRef);
  const rowSelector = gridPaginationRowRangeSelector(apiRef);
  
  const [scrollPositionLeft, setScrollPositionLeft] = React.useState(0);

  const column6Width = (columnPositionsSelector[7] - columnPositionsSelector[6]) + 'px';
  const column7Width = (columnPositionsSelector[8] - columnPositionsSelector[7]) + 'px';

  const summaryStartPosition = (columnPositionsSelector[6] - scrollPositionLeft - 60) + 'px';
  const viewportWidth = apiRef.current.getRootDimensions()?.viewportInnerSize.width + 'px';

  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const pagination = apiRef.current.state.pagination;
  const rowsCount = apiRef.current.getVisibleRowModels().size;

  const firstRowIndex = rowSelector ? pagination.page*pagination.pageSize + 1 : 0;
  const lastRowIndex = rowSelector ? rowSelector.lastRowIndex+1 : 0;

  React.useEffect(() => {
    apiRef.current.subscribeEvent(
      'rowsScroll',
      handleEvent,
    );
  }, []);

  function handleEvent(params) {
    setScrollPositionLeft(params.left);
  }  

  return (
    <GridFooterContainer sx={{ overflow: 'hidden' }}>
      <Stack direction="column" justifyContent="flex-end" alignItems="space-between" spacing={2} width={viewportWidth}>
          <Styled.SummaryInnerWrapper sx={{left:summaryStartPosition}}>
            <Styled.Label sx={{width:'60px'}}>Suma:</Styled.Label>
            <Styled.Label sx={{minWidth:column6Width}}>{format(bankersRounding(props.totalAmountNet, 2))}&nbsp;PLN</Styled.Label>
            <Styled.Label>{format(bankersRounding(props.totalAmount, 2))}&nbsp;PLN</Styled.Label>
          </Styled.SummaryInnerWrapper>
        <Styled.Divider />
        <Styled.Wrapper sx={{width: viewportWidth}}>
          <Stack justifyContent="center" alignItems="center">
            <MDTypography sx={{fontWeight:400, ml:1}} fontSize={13} color='text' left={columnPositionsSelector[7]} variant="button">
              Wyświetlam {firstRowIndex} do {pagination.page*pagination.pageSize + rowsCount} z {apiRef.current.getRowsCount()} pozycji
            </MDTypography>
          </Stack>
          <Pagination
            sx={{p:2}}
            color="primary"
            count={pageCount}
            renderItem={props2 => <PaginationItem {...props2} disableRipple />}
            onChange={(event, value) => {
              apiRef.current.setPage(value-1)}
            }  />
        </Styled.Wrapper>
      </Stack>
    </GridFooterContainer>
  );
}

CustomTotalsComponent.propTypes = {
  total: PropTypes.number
};

export { CustomTotalsComponent };
